export const VALIDATE_PAGE_SIZE = 10;
export const NON_VALIDATE_PAGE_SIZE = 100;
export const MAX_PAGE_SIZE = 100;

export interface Project {
  name: string;
  webUrl: string;
  fullPath: string;
  id: number;
}

export interface Product {
  name: string;
  pmProjectPath?: string;
  projects: Project[];
  directProjects: Project[];
  groupPaths: string[];
}

export interface ProductRaw {
  name: string;
  projectPaths: string[];
  pmProjectPath?: string;
  groupPaths: string[];
}

export interface ReportParams {
  validateNotes: boolean;
  product: Product;
  projects: Project[];
  from: Date;
  to: Date;
}

export type RecordFunc = (params: ReportParams) => void;

export interface UserInfo {
  url: string;
  avatar: string;
  name: string;
  username: string;
}

export type IssueShortened = Omit<Issue, 'timeLogs'>;

export interface TimeLog {
  id: string;
  issue: IssueShortened;
  user: UserInfo;
  timeSpent: number;
  spentAt: Date;
  summary: string;
}

export interface Milestone {
  title: string;
  createdAt: Date;
  dueDate?: Date;
}

export interface Issue {
  id: string;
  iid: number;
  title: string;
  state: string;
  createdAt: Date;
  updatedAt: Date;
  webUrl: string;
  labels: string[];
  time_stats: {
    time_estimate?: number;
    total_time_spent?: number;
  };
  timeLogs: TimeLog[];
  timeLogsFullLength?: number;
  notesFullLength?: number;
  milestone: Milestone | null;
  links?: { id: string; project: Project }[];
  project: Project;
}

export interface IncorrectTimeNote {
  shortIssue: IssueShortened;
  noteId: number;
  createdAt: Date;
  spentAt: Date;
  author: UserInfo;
}
